import { render, staticRenderFns } from "./TaxonomySingleSettings.vue?vue&type=template&id=b8a45ace&"
import script from "./TaxonomySingleSettings.vue?vue&type=script&lang=js&"
export * from "./TaxonomySingleSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports